/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Back_To_LoginInputs */



/**
* | output |
* | --- |
* | "Back to login" |
*
* @param {Login_Back_To_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_back_to_login = /** @type {((inputs?: Login_Back_To_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Back_To_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à la connexion")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver al inicio de sesión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Voltar para o login")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna all'accesso")
	return /** @type {LocalizedString} */ ("Back to login")
});